import React from 'react';
const MSOfficeLiveViewer = props => {
    const { title, url, className } = props;
    const proxyUrl = new URL('/op/view.aspx', 'https://view.officeapps.live.com');
    proxyUrl.searchParams.append('src', encodeURI(url));
    return (React.createElement("iframe", { width: '100%', height: '100%', title: title, src: proxyUrl.href, className: className }));
};
export default MSOfficeLiveViewer;
//# sourceMappingURL=MSOfficeLiveViewer.js.map